<template>
  <span>
    <v-tooltip v-if="display" top>
      <template #activator="{ on: tooltip }">
        <span v-on="{ ...tooltip }">
          <slot></slot>
        </span>
      </template>
      <span v-if="addon">{{
        isTrial
          ? $t('Permissions.testOnTrialAddon', getAddons(permission))
          : $t('Permissions.upgradeToAddon', getAddons(permission))
      }}</span>
      <span v-else>{{
        isTrial
          ? $t('Permissions.testOnTrial', getPermissionPlans(permission))
          : $t('Permissions.upgradeToPlan', getPermissionPlans(permission))
      }}</span>
    </v-tooltip>
    <slot v-else-if="!hide"></slot>
  </span>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'LimitedFeatureTooltip',
  props: {
    permission: {
      type: [String, Array],
      default: '',
    },
    addon: Boolean,
    hide: Boolean,
  },
  methods: {},
  computed: {
    ...mapState(['accountInfo']),
    ...mapGetters(['checkPermission', 'getPermissionPlans', 'getAddons']),
    isTrial() {
      return this.accountInfo.planName === 'Trial';
    },
    display() {
      return (
        (this.permission && !this.checkPermission(this.permission)) ||
        (this.permission && this.isTrial)
      );
    },
  },
};
</script>

<style></style>
